import { useCallback as e, useMemo as t, useState as n } from "react";
import { AiPageKind as r } from "@maat/api-ai/types";
//#region src/hooks/usePageContext.ts
var i = ({ context: e }) => `${e.kind}:${e.kind === r.Booking ? e.bookingId : e.listingId}`, a = () => {
	let [r, a] = n(null), [o, s] = n(null), c = e((e) => (a(e), () => a((t) => t === e ? null : t)), []);
	return {
		activePage: t(() => r && i(r) !== o ? r : null, [r, o]),
		publishPage: c,
		dismissPage: e(() => {
			r && s(i(r));
		}, [r])
	};
};
//#endregion
export { a as usePageContext };
